import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const MetaCallback: React.FC = () => {
  const [params] = useSearchParams();

  useEffect(() => {
    const key = params.get('key');
    const error = params.get('meta_error');
    if (window.opener) {
      window.opener.postMessage({ type: 'META_OAUTH', key, error }, window.location.origin);
      window.close();
    } else {
      window.location.href = '/calendar' + (error ? `?meta_error=${encodeURIComponent(error)}` : '');
    }
  }, []);

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', fontFamily:'"Montserrat",sans-serif', background:'#f1f5f9' }}>
      <div style={{ textAlign:'center', color:'rgba(15,42,74,0.5)', fontSize:'14px' }}>
        Conectando con Meta...
      </div>
    </div>
  );
};

export default MetaCallback;
